<template>
    <div class="form-wrap">
        <div class="form-item">
            <div class="item-title">申请BU：</div>
            <div class="item-text">{{ data.bu_name }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">申请周期：</div>
            <div class="item-text">{{ data | cycleStr }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">申请理由：</div>
            <div class="item-text">{{ data.remark }}</div>
        </div>
        <div class="form-item" v-show="data.status!=1">
            <div class="item-title">审核说明：</div>
            <div class="item-text">{{ data.result || "无" }}</div>
        </div>


        <sliderHistoty :data="data.req"></sliderHistoty>

        <!-- 审核 -->
        <div v-if="data.status==1 && $route.name!='my-application'"  v-form:apply-delay>
            <div class="form-line" text="审核处理"></div>

            <div class="form-item">
                <div class="item-title">审核说明：</div>
                <div class="item-wrap">
                    <textarea rule="reason" v-arg="'审核说明'" v-tar="examine.result" v-model="examine.result" placeholder="请输入审核说明"></textarea>
                </div>
            </div>

            <div class="form-footer">
                <el-button type="primary" @click="checkPass">通 过</el-button>
                <el-button type="primary" @click="checkNotPass">不通过</el-button>
            </div>
        </div>

        <!-- 重新提交 -->
        <div v-if="data.status == 3 &&  $route.name=='my-application'" v-form:delay-again>
            <div class="form-line" text="申请"></div>

            <div class="form-item">
                <div class="item-title">申请理由：</div>
                <div class="item-wrap">
                    <textarea v-tar="resub.delay_reason" rule="reason" v-arg="['申请理由']" v-model="resub.delay_reason" placeholder="请输入申请理由"></textarea>
                </div>
            </div>
            <div class="form-footer">
                <el-button type="primary" @click="subAgain">重新提交</el-button>
            </div>

        </div>

    </div>
</template>

<script>
    import sliderHistoty from "src/components/slider/slider_history.vue"

    export default {
        props:["data","resub","examine"],
        components:{
            sliderHistoty,
        },
        data(){
            return {

            }
        },

        computed:{
        },

        watch:{
            data(val){
                let count = 0;
                for(let i in val){
                    count++;
                };
                if(count == 0){
                    this.$form.clear("delay-again");
                    this.$form.clear("apply-delay");
                }
            },
        },

        methods:{
            checkPass(){
                let res = this.$form.check("apply-delay");
                if(!res){
                    return;
                }
                this.$emit('pass');
            },
            checkNotPass(){
                let res = this.$form.check("apply-delay");
                if(!res){
                    return;
                }
                this.$emit('notpass');
            },
            subAgain(){  //重提交
                let res = this.$form.check("delay-again");
                if(!res){
                    return;
                }

                let url = `api/manager/curr_trans_req/${this.data.id}`;
                this.$http.put(url,{
                    remark:this.resub.delay_reason,
                }).then(res=>{
                    if(res.status == 200){
                        this.successTip("重新提交成功");
                        this.$emit("refresh");
                    }
                }).catch(error=>{
                    this.errorTip("提交失败");
                });

            },
        }
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/slider.less";
</style>





// WEBPACK FOOTER //
// sliderDelay.vue?cacca2a0